export const dialogTokenLocale = {
    retirada: {
        codeText: 'Código de retirada:',
        subtitle: 'Informe o código para o entregador e <strong>aguarde a validação</strong> para liberar o pedido.',
        orderText: 'Pedido liberado para entrega',
        helpText: 'Se houver problemas na validação ou na retirada do pacote, entre em contato com o SAL.',
        buttonText: 'Confirmar retirada',
    },
    devolucao: {
        codeText: 'Código de devolução:',
        subtitle: 'Informe o código para o entregador e aguarde a validação.',
        orderText: 'Pedido liberado para devolução',
        helpText: 'Se houver problemas na validação, entre em contato com o SAL.',
        buttonText: 'Confirmar devolução',
    }
}